<template>
  <v-container fill-height>
    <v-layout text-center row wrap justify-center>
      <v-flex xs10>
        <Title title="Fahrer" subtitle="Gib hier deine Fahrernummer an" />

        <v-text-field
          v-model="driverID"
          type="number"
          pattern="[0-9]*"
          placeholder="Fahrernummer"
          solo
          @change="updateDriver()"
        ></v-text-field>

        <span v-if="driverName" class="body-2">Hallo, {{ driverName }}!</span>

        <span v-if="showLoading" class="loading-circle"></span>

        <div class="mt-8">
          <v-btn to="/route" color="green" dark large :disabled="disabled">Weiter</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Title from "@/components/Title";

export default {
  components: {
    Title
  },
  data: () => ({
    disabled: true,
    driverID: "",
    driverName: "",
    showLoading: false
  }),
  methods: {
    updateDriver() {
      this.showLoading = true;

      fetch(`${process.env.VUE_APP_API_URI}/drivers/${this.driverID}`, {
        headers: new Headers({
          Authorization:
            "Basic " +
            btoa(`${process.env.VUE_APP_USER}:${process.env.VUE_APP_PASSWORD}`),
          "Content-Type": "application/x-www-form-urlencoded"
        })
      })
        .then(res => res.json())
        .then(res => {
          this.showLoading = false;

          if (res.driver) {
            const driverName = `${res.driver.firstName} ${res.driver.lastName}`;
            this.driverName = driverName;

            const driver = {
              id: res.driver._id,
              name: driverName
            };

            this.$store.commit("updateDriver", driver);

            this.disabled = false;
          } else {
            alert("Fahrernummer existiert nicht");
            this.driverID = "";
            this.disabled = true;
          }
        });
    }
  }
};
</script>
